import { memo } from 'react';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import { getCookie } from 'root/src/client/v2/browser/helpers/cookies';
import { useRedesignModal } from 'root/src/client/v2/common/contexts/redesignModal.context';
import { RedesignCreateGiveawayModal } from 'root/src/client/v2/giveaways/features/CreateGiveawayModal/RedesignCreateGiveawayModal';
import { RedesignGiveawayHistoryModal } from 'root/src/client/v2/giveaways/features/GiveawayHistory/RedesignGiveawayHistoryModal';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, } from 'root/src/client/v2/common/components/ui/tooltip';
import { useCreatorGiveaways } from 'root/src/client/v2/_pages/creator/redesign/useCreatorGiveaways';
export const CreatorGiveawayPanel = memo(({ creator }) => {
    const modal = useRedesignModal();
    const { active, isLoading } = useCreatorGiveaways(creator.userId);
    const isOwnProfile = Boolean(creator.userId) && getCookie('userId') === creator.userId;
    const statusText = (() => {
        if (isLoading) {
            return 'Loading...';
        }
        return active ? 'A giveaway is live now' : 'No active giveaway';
    })();
    return (<div className="glass relative h-full rounded-2xl border border-solid border-white/[0.08] border-t-2 border-t-neon-amber/30 p-6 sm:p-8">
			{isOwnProfile && (<TooltipProvider delayDuration={150}>
					<Tooltip>
						<TooltipTrigger asChild>
							<button type="button" aria-label="Giveaway history" onClick={() => modal.show(<RedesignGiveawayHistoryModal />)} className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-white/[0.06] hover:text-foreground">
								<HistoryRoundedIcon sx={{ fontSize: 18 }}/>
							</button>
						</TooltipTrigger>
						<TooltipContent>Giveaway history</TooltipContent>
					</Tooltip>
				</TooltipProvider>)}
			<h2 className="text-center font-display text-lg font-bold text-foreground">My Giveaway</h2>

			<div className="mt-4 flex justify-center">
				<div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-muted">
					<EmojiEventsOutlinedIcon className="text-neon-amber"/>
				</div>
			</div>

			<p className="mt-3 text-center text-sm text-muted-foreground">{statusText}</p>

			{isOwnProfile && (<div className="mt-5 flex flex-col items-center gap-2.5">
					<button type="button" onClick={() => modal.show(<RedesignCreateGiveawayModal />)} className="inline-flex items-center gap-1.5 rounded-xl bg-gradient-to-r from-neon-pink to-neon-purple px-5 py-2.5 text-sm font-semibold text-white transition-shadow hover:shadow-[0_0_20px_-5px_hsl(var(--neon-pink)/0.4)]">
						{active ? 'Manage giveaway' : '+ Create Giveaway'}
					</button>
				</div>)}
		</div>);
});
